import {
  JOB_CARD_REPORT,
    ORDER_REPORT,
    PO_REPORT,
    JOB_CARD_REPORT_EXPORT,
    ORDER_REPORT_EXPORT,
    PO_REPORT_EXPORT,
    GET_VENDOR_LIST
  } from "./ApiRoutes"; // Ensure these routes are defined in your ApiRoutes file
  import { authData } from "./services"; // Assuming authData is set up for API calls

export const orderReport = async (data: object) => {
    const response = await authData.post(ORDER_REPORT, data);
    console.log('product fetch')
    return response;
  }

  export const POReport = async (data: object) => {
    const response = await authData.post(PO_REPORT,data);
    return response;
  }

  export const JobCardReports = async (data: object) => {
    const response = await authData.post(JOB_CARD_REPORT,data);
    return response;
  }

  export const exportJobReport = async (data: object) => {
    const response = await authData.post(JOB_CARD_REPORT_EXPORT,data);
    return response;
  }

  export const exportOrderReport = async (data: object) => {
    const response = await authData.post(ORDER_REPORT_EXPORT,data);
    return response;
  }

  export const exportPOReport = async (data: object) => {
    const response = await authData.post(PO_REPORT_EXPORT,data);
    return response;
  }

  export const getVendorList = async () => {
    const response = await authData.get(GET_VENDOR_LIST);
    return response.data;
  }